<template lang="pug">
	.campaign-geotargeting.flex-col.space
		RegionSelectorMap(:data="geoTargeting", :regions="geoTargeting.locations", @regions-change="v => geoTargeting.locations = v", :hideMap="true", :readonly="info.readonly")
		ZipsMap(v-if="info.configLoaded", ref="map", :locations="geoTargeting.locations", :selectedZips="geoTargeting.customZips.added", @zips-change="onZipsChange", :readonly="info.readonly", :config="config",
			:countryCode="info.countryCode", @group-summary-calculated="onGroupSummaryCalculated", @image-generated="onImageGenerated", @zips-loaded="makeScreen")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import RegionSelectorMap from 'view/carto/RegionSelectorMapGeotargeting.vue';
	import CartoMapGeotargeting from 'view/carto/CartoMapGeotargeting.vue';
	import ZipsMap from 'view/maps/ZipsMap.vue';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-geotargeting',
		components: {
			Loader, RegionSelectorMap, CartoMapGeotargeting, ZipsMap
		},
		props: ['info', 'mapPosition'],
		data() {
			return {
				geoTargeting: {
					locations: this.info.campaign?.JsonConfig.geoTargeting?.locations || [],
					imageGeotargeting: null,
					customZips: {
						added: this.info?.campaign.JsonConfig.geoTargeting?.zips?.include || [],
						removed: this.info?.campaign.JsonConfig.geoTargeting?.zips?.exclude || [],
						final: this.info?.campaign.JsonConfig.geoTargeting?.zips?.final || []
					}
				}
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			},
			config() {
				return this.info?.countryConfig;
			},
		},
		watch: {
			'geoTargeting.locations': {
				handler(v) {
					if (__DEBUG__)
						console.debug('geoTargeting.locations changed', { v })
					this.$set(this.campaign?.JsonConfig?.geoTargeting, 'locations', v);

					if (!v.length) {
						this.geoTargeting.customZips = {
							added: [],
							removed: [],
							final: []
						}
					}
				},
				deep: true
			},
			'geoTargeting.imageGeotargeting'(v) {
				if (__DEBUG__)
					console.debug('Image geotargeting', v);
				this.campaign.__updateCampaignImage('ImageGeotargeting', v).then(r => {
					this.campaign.ImageGeographiesUrl = this.campaign.ImageGeotargetingUrl;
				});
			},
			'geoTargeting.customZips': {
				handler(v) {
					this.$set(this.campaign?.JsonConfig?.geoTargeting, 'zips', {
						include: v?.added || [],
						exclude: v?.removed || []
					});
				},
				deep: true
			},
		},
		mounted() {
			if (__DEBUG__)
				window.campaignGeotargeting = this;

			if (!this.campaign.JsonConfig.geoTargeting) {
				this.$set(this.campaign.JsonConfig, 'geoTargeting', {
					locations: [],
					zips: {
						include: [],
						exclude: [],
						final: []
					},
					targets: []
				});
			}

			this.$makeScreen = _.debounce(() => {
				this.$refs.map.generateScreen();
			}, 1000, {
				'leading': false,
				'trailing': true
			});
		},
		destroyed() {			
		},
		methods: {
			onGroupSummaryCalculated(e) {
				if (__DEBUG__)
					console.debug('onGroupSummaryCalculated', e);

				if (!this.campaign.PopulationStatistic?.Items) {
					this.campaign.PopulationStatistic = {
						...(this.campaign.PopulationStatistic || {}),
						Items: []
					}
				}

				let items = this.campaign.PopulationStatistic.Items;
				let summary = e?.summary || [];
				summary.map(s => {
					let item = items.find(f => f.GroupKey === s.fieldName);
					if (!item) {
						item = {
							GroupKey: s.fieldName,
							Name: s.key
						}
						items.push(item);
					}
					item.Amount = s.value;
				});
			},
			onZipsChange(v, population) {
				this.geoTargeting.customZips.added = v;

				this.campaign.PopulationStatistic = {
					...(this.campaign.PopulationStatistic || {}),
					TotalPopulation: population
				}

				this.$makeScreen();
			},
			onImageGenerated(dataUri) {
				this.geoTargeting.imageGeotargeting = dataUri;
			},
			makeScreen() {
				this.$makeScreen();
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-geotargeting {

		
	}
</style>
 